import { put } from 'services/api/base';

import { ChangeCampaignNameRequest } from './types-change-pos-campaign-name';

export function changePosCampaignName(request: ChangeCampaignNameRequest): Promise<void> {
  return put(`v5/pos/campaigns/${request.campaignId}`, {
    json: { campaignName: request.campaignName },
  }).json();
}
